import { Injectable } from '@angular/core';
import {
  Actions,
  createEffect,
  ofType,
} from '@ngrx/effects';

import {
  catchError,
  map,
  of,
  switchMap,
} from 'rxjs';

import { EnrolleeService } from '../../services/moduleServices/enrolle.service';

import {
  EnrolleeByIdResponse,
  SelfEnrolleeDetailsResponse,
} from '../../interfaces/enrollee.interface';

import * as EnrolleeActions from './enrollee.actions';

@Injectable()
export class EnrolleeEffects {
  loadCurrentEnrollee$;

  constructor(
    private readonly actions$: Actions,
    private readonly enrolleeService: EnrolleeService
  ) {
    this.loadCurrentEnrollee$ = createEffect(() =>
      this.actions$.pipe(
        ofType(EnrolleeActions.loadCurrentEnrollee),

        switchMap(() =>
          this.enrolleeService.getEnrolleeDetails().pipe(
            switchMap((detailsResponse) => {
              if (
                detailsResponse?.IsSuccess !== true ||
                !detailsResponse?.Value
              ) {
                return of(
                  EnrolleeActions.loadCurrentEnrolleeFailure({
                    error:
                      detailsResponse?.Value?.Message ||
                      'Unable to retrieve self-enrollee details.',
                  })
                );
              }

              const enrollmentId =
                detailsResponse.Value.EnrollmentId;

              if (
                !Number.isInteger(enrollmentId) ||
                enrollmentId <= 0
              ) {
                return of(
                  EnrolleeActions.loadCurrentEnrolleeFailure({
                    error:
                      'getEnrolleeDetails returned an invalid EnrollmentId.',
                  })
                );
              }

              return this.enrolleeService
                .getEnrolleeByIdPolicyPortal(enrollmentId)
                .pipe(
                  map((response) => {
                    if (
                      response?.IsSuccess !== true ||
                      !response?.Value
                    ) {
                      return EnrolleeActions
                        .loadCurrentEnrolleeFailure({
                          error:
                            response?.Value?.Message ||
                            'Unable to retrieve enrollee record.',
                        });
                    }

                    return EnrolleeActions
                      .loadCurrentEnrolleeSuccess({
                        enrollmentId,
                        enrollee: response.Value,
                      });
                  }),

                  catchError((error: any) =>
                    of(
                      EnrolleeActions
                        .loadCurrentEnrolleeFailure({
                          error:
                            error?.error?.Message ||
                            error?.error?.message ||
                            error?.message ||
                            'Unable to retrieve enrollee record.',
                        })
                    )
                  )
                );
            }),

            catchError((error: any) =>
              of(
                EnrolleeActions.loadCurrentEnrolleeFailure({
                  error:
                    error?.error?.Message ||
                    error?.error?.message ||
                    error?.message ||
                    'Unable to retrieve self-enrollee details.',
                })
              )
            )
          )
        )
      )
    );
  }
}